<script>
    import I18n from '@js/modules/translations';
    import {activateOnKey} from '@js/modules/a11y';

    import {DefaultRideType} from '@js/components/modules/constants';

    import Dropdown from '@js/components/themes/Dropdown.svelte';
    import Icon from '@js/components/themes/Icon.svelte';
    import {RIDE_TYPE_ICON} from '@js/components/themes/icons';

    const {
        name,
        label = I18n.t('js.ride.model.ride_type'),
        defaultValue = window.currentUserRideType || DefaultRideType,
        onRideTypeChange
    } = $props();

    let rideType = $state(defaultValue);

    let _pickedByUser = false;

    const _handleRideTypeChange = (routeType, event) => {
        _pickedByUser = true;
        event.preventDefault();

        rideType = routeType;

        if (onRideTypeChange) {
            onRideTypeChange(routeType);
        }
    };

    $effect(() => {
        const incoming = defaultValue;

        if (_pickedByUser) {
            return;
        }

        rideType = incoming;
    });
</script>

<Dropdown label={label}
          class="mx-auto w-full"
          buttonClass="w-full px-4 py-2 flex justify-between rounded-lg text-sm"
          color="gray"
          name={name}
          optionSize={Object.keys(RIDE_TYPE_ICON).length}
          selected={rideType}
          closeClickInside={true}>
    {#snippet dropdownButtonRender()}
        <span class="flex items-center justify-center">
            <Icon class="inline-flex h-4 w-4 me-2"
                  icon={RIDE_TYPE_ICON[rideType]}/>
            {I18n.t(`js.ride.enums.ride_type.${rideType}`)}
        </span>
    {/snippet}

    <ul class="text-sm text-gray-700 dark:text-gray-200"
        role="listbox"
        aria-labelledby="RouteType">
        {#each Object.keys(RIDE_TYPE_ICON) as routeType (routeType)}
            <li class="flex items-center justify-start p-2 cursor-pointer hover:bg-gray-300"
                class:bg-primary-200={rideType === routeType}
                role="option"
                aria-selected={rideType === routeType}
                tabindex="0"
                onclick={_handleRideTypeChange.bind(null, routeType)}
                onkeydown={activateOnKey(_handleRideTypeChange.bind(null, routeType))}>
                <Icon class="h-4 w-4 me-3"
                      icon={RIDE_TYPE_ICON[routeType]}/>
                {I18n.t(`js.ride.enums.ride_type.${routeType}`)}
            </li>
        {/each}
    </ul>
</Dropdown>
